import { SET_SCROLL_SPEED } from '../actionConstants';

export const setScrollSpeedAction = (payload) => {
  return {
    type: SET_SCROLL_SPEED,
    payload,
  };
};
